import React, { useState, useRef } from 'react';
import Header from '../Header/Header';
import Footer from '../footer/Footer';
import { Link } from 'react-router-dom';
import { FiPlusCircle, FiVolume2, FiVolumeX, FiPause, FiPlay } from 'react-icons/fi';
import { motion } from 'framer-motion';
import './Home.css';
import ListeAnnonce from '../listeannonce/ListeAnnonce';
import Testimonials from '../testimonials/Testimonials';
import HowItWorks from '../how-it-works/HowItWorks';
import Mission from '../mission/Mission';
import Services from '../services/Services';
import CTA from '../cta/CTA';

const Home = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const [isVideoMuted, setIsVideoMuted] = useState(true);
  const videoRef = useRef(null);

  // Contrôle de la vidéo
  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isVideoPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsVideoPlaying(!isVideoPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isVideoMuted;
      setIsVideoMuted(!isVideoMuted);
    }
  };

  return (
    <div className="home-container">
      <Header />

      {/* Bannière principale avec vidéo - Design refait */}
      <section className="hero-banner">
        <div className="hero-content-container">
          <div className="hero-text-content">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="hero-title"
            >
              Nous facilitons l'entraide et l'intégration des étudiants étrangers en France
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="hero-subtitle"
            >
              ETEF – Votre guide pour votre intégration et votre accompagnement tout au long de vos études en France
            </motion.p>
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="hero-cta"
            >
              <Link to="/ajouter-annonce" className="hero-btn primary">
                <FiPlusCircle className="icon" /> Déposer une annonce
              </Link>
              <Link to="/a-propos" className="hero-btn secondary">
                Découvrir nos services
              </Link>
            </motion.div>
          </div>
          <div className="hero-video-content">
            <video 
              ref={videoRef}
              autoPlay 
              muted={isVideoMuted}
              loop 
              playsInline
              className="hero-video"
            >
              <source src={require('../../assets/images/videoplayback.mp4')} type="video/mp4" />
              Votre navigateur ne supporte pas la vidéo.
            </video>
            <div className="video-controls">
              <button 
                className="video-control-btn"
                onClick={togglePlayPause}
                aria-label={isVideoPlaying ? "Mettre en pause" : "Lire la vidéo"}
              >
                {isVideoPlaying ? <FiPause size={18} /> : <FiPlay size={18} />}
              </button>
              <button 
                className="video-control-btn"
                onClick={toggleMute}
                aria-label={isVideoMuted ? "Activer le son" : "Désactiver le son"}
              >
                {isVideoMuted ? <FiVolumeX size={18} /> : <FiVolume2 size={18} />}
              </button>
            </div>
          </div>
        </div>
        <div className="wave-divider">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </section>

      <Mission />
      <Services />
      <ListeAnnonce />
      <HowItWorks />
      <Testimonials />
      <CTA />
      
      <Footer />
    </div>
  );
};

export default Home;